import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import React, { useEffect, useState } from "react";
import cup from "../../../../../assets/images/page 1.png";
import "./PostContentMaking.css";
import { useHistory, useParams } from "react-router-dom";
import axios from "axios";
import ReactPlayer from "react-player";
import swal from "sweetalert";
import moment from "moment";
import Multiselect from "multiselect-react-dropdown";
import { LocalizationProvider } from "@mui/lab";
import { MenuItem, Select, Stack, TextField } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { serverInfo } from "../../../../../App";
import { useContext } from "react";
import LoaderPost from "../../../../Reuseable/LoaderPost";
const StarRoundInstructionVideoCreate = () => {
  const { imageCdnUrl } = useContext(serverInfo);
  const history = useHistory();
  const { id } = useParams();
  const [event, setEvent] = useState({});

  const [loading, setLoading] = useState(false);
  const [events, setEvents] = useState([]);
  const [rounds, setRounds] = useState([]);
  const [auditionId, setAuditionId] = useState("");
  const [roundId, setRoundId] = useState("");
  const [file, setFile] = useState("");
  const [imageData, setImageData] = useState("");
  const [fileVideo, setFileVideo] = useState("");
  const [filePdf, setFilePdf] = useState("");
  const [videoFile, setVideoFile] = useState("");
  const [judges, setJudges] = useState([]);
  const [convertedContent, setConvertedContent] = useState(null);
  const [description, setDescription] = useState(null);
  const [errorList, setErrorList] = useState([]);

  const submitRoundInstruction = (e) => {
    e.preventDefault();
    const fData = new FormData();

    fData.append("instruction", convertedContent);
    fData.append("description", description);
    fData.append("video", fileVideo);
    fData.append("image", imageData);
    fData.append("pdf", filePdf);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .post(
          `/api/superstar/audition/round-instruction-video/update/${id}`,
          fData
        )
        .then((res) => {
          if (res.data.status === 200) {
            swal("Success", res.data.message, "success");
            // fetchAuditions();
            // history.goBack();
          } else {
            setErrorList(res.data.validation_errors);
          }
        });
    });
  };

  const handleImageChange = (file) => {
    setFile(URL.createObjectURL(file[0]));
    setImageData(file[0]);
  };
  const handleVideoChange = (file) => {
    setFileVideo(file[0]);
    setVideoFile(URL.createObjectURL(file[0]));
  };

  const handlePdfChange = (file) => {
    setFilePdf(file[0]);
  };

  const fetchAuditions = () => {
    axios
      .get(`/api/superstar/audition/round-instruction-video/details/${id}`)
      .then((res) => {
        if (res.data.status === 200) {
          setEvents(res.data.events);
          // setLoading(false);
        }
      });
  };

  useEffect(() => {
    fetchAuditions();
  }, []);

  return (
    <>
      {loading === true ? (
        <LoaderPost />
      ) : (
        <>
          <div className="liveMeetupBorder">
            <div className="d-flex px-4">
              <div className="faTrophy p-2">
                <img src={cup} alt="" className="mt-1" width="30px" />{" "}
                <span className="text-waning p-2 fw-bolder">
                  Get Round Instruction Video from Star
                </span>
              </div>
            </div>
            <div className="my-2">
              <form
                onSubmit={submitRoundInstruction}
                id="input_form"
                encType="multipart/form-data"
              >
                <div className="row ms-5">
                  <div className="form-group row mt-3">
                    <label
                      for="description"
                      className="col-sm-2 col-form-label text-light "
                    >
                      Description
                    </label>
                    <div className="col-sm-8">
                      <CKEditor
                        editor={ClassicEditor}
                        data={description}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setDescription(data);
                        }}
                      />
                      <span className="text-danger">
                        {errorList.description}
                      </span>
                    </div>
                  </div>

                  <div className="form-group row mt-3">
                    <label
                      for="instruction"
                      className="col-sm-2 col-form-label text-light "
                    >
                      Instruction
                    </label>
                    <div className="col-sm-8">
                      <CKEditor
                        editor={ClassicEditor}
                        data={convertedContent}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setConvertedContent(data);
                        }}
                      />
                      <span className="text-danger">
                        {errorList.instruction}
                      </span>
                    </div>
                  </div>

                  <div className="form-group row mt-3">
                    <label
                      for="staticEmail"
                      className="col-sm-3 col-form-label text-light "
                    >
                      Upload Video
                    </label>

                    <div className="col-sm-7 mb-2">
                      <div className="row my-4">
                        <div className="col-md-10">
                          {videoFile ? (
                            <>
                              <ReactPlayer
                                url={videoFile}
                                // width="100%"
                                controls={true}
                                height="35vh"
                              />
                            </>
                          ) : (
                            <></>
                          )}
                          <input
                            type="file"
                            name="file"
                            id="setFile"
                            className="inputfile w-25"
                            accept="video/mp4"
                            onChange={(e) => handleVideoChange(e.target.files)}
                          />

                          <label for="setFile">
                            <i className="fas fa-cloud-upload-alt"></i> Upload
                            Video
                          </label>
                          <span className="text-danger">{errorList.video}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="form-group row mt-3">
                    <label
                      for="staticEmail"
                      className="col-sm-3 col-form-label text-light "
                    >
                      Upload Image
                    </label>

                    <div className="col-sm-7 mb-2">
                      <div className="row my-4">
                        {file ? (
                          <img
                            src={file}
                            alt="..."
                            className="demo-preview-image img-fluid"
                          />
                        ) : (
                          ""
                        )}
                        <div className="col-md-10">
                          <input
                            type="file"
                            name="imageFile"
                            id="imageFile"
                            className="inputfile w-25"
                            accept="image/jpg,image/jpeg, image/png"
                            onChange={(e) => handleImageChange(e.target.files)}
                          />

                          <label for="imageFile">
                            <i className="fas fa-cloud-upload-alt"></i> Upload
                            Image
                          </label>
                          <span className="text-danger">{errorList.image}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="form-group row mt-3">
                    <label
                      for="staticEmail"
                      className="col-sm-3 col-form-label text-light "
                    >
                      Instruction pdf for the round
                    </label>

                    <div className="col-sm-7 mb-2">
                      <div className="row d-flex justify-content-end my-4">
                        <div className="col-md-2 text-white"></div>
                        <div className="col-md-3 inputeParent">
                          <input
                            type="file"
                            name="pdfFile"
                            id="pdfFile"
                            accept=".pdf"
                            className="inputfile w-25"
                            onChange={(e) => handlePdfChange(e.target.files)}
                          />
                          <label for="pdfFile">
                            <i className="fa-solid fa-file-pdf"></i> 1 MB
                            Maximum
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row justify-content-end my-4">
                    <div className="col-md-3 text-left">
                      <button
                        className="btn btn-warning px-4 fw-bold"
                        type="submit"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default StarRoundInstructionVideoCreate;
